/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ScannerMappingDto,
  VulnerabilityScannerMappingStalenessResponse,
  VulnerabilityScannerMappingUpsertRequest,
} from '../models/index';
import {
    ScannerMappingDtoFromJSON,
    ScannerMappingDtoToJSON,
    VulnerabilityScannerMappingStalenessResponseFromJSON,
    VulnerabilityScannerMappingStalenessResponseToJSON,
    VulnerabilityScannerMappingUpsertRequestFromJSON,
    VulnerabilityScannerMappingUpsertRequestToJSON,
} from '../models/index';

export interface GetVulnerabilityScannerMappingStalenessRequest {
    sessionId: string;
    limit?: number;
}

export interface UpsertVulnerabilityScannerMappingRequest {
    sessionId: string;
    vulnerabilityScannerMappingUpsertRequest: VulnerabilityScannerMappingUpsertRequest;
}

/**
 * MDMScannerMappingsApi - interface
 * 
 * @export
 * @interface MDMScannerMappingsApiInterface
 */
export interface MDMScannerMappingsApiInterface {
    /**
     * 
     * @summary Stale scanner mappings (REQ-V3-05)
     * @param {string} sessionId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMScannerMappingsApiInterface
     */
    getVulnerabilityScannerMappingStalenessRaw(requestParameters: GetVulnerabilityScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VulnerabilityScannerMappingStalenessResponse>>;

    /**
     * Stale scanner mappings (REQ-V3-05)
     */
    getVulnerabilityScannerMappingStaleness(requestParameters: GetVulnerabilityScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VulnerabilityScannerMappingStalenessResponse>;

    /**
     * 
     * @summary Upsert scanner mapping row
     * @param {string} sessionId 
     * @param {VulnerabilityScannerMappingUpsertRequest} vulnerabilityScannerMappingUpsertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMScannerMappingsApiInterface
     */
    upsertVulnerabilityScannerMappingRaw(requestParameters: UpsertVulnerabilityScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerMappingDto>>;

    /**
     * Upsert scanner mapping row
     */
    upsertVulnerabilityScannerMapping(requestParameters: UpsertVulnerabilityScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerMappingDto>;

}

/**
 * 
 */
export class MDMScannerMappingsApi extends runtime.BaseAPI implements MDMScannerMappingsApiInterface {

    /**
     * Stale scanner mappings (REQ-V3-05)
     */
    async getVulnerabilityScannerMappingStalenessRaw(requestParameters: GetVulnerabilityScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VulnerabilityScannerMappingStalenessResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getVulnerabilityScannerMappingStaleness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/vulnerabilities/scanner-mappings/staleness`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VulnerabilityScannerMappingStalenessResponseFromJSON(jsonValue));
    }

    /**
     * Stale scanner mappings (REQ-V3-05)
     */
    async getVulnerabilityScannerMappingStaleness(requestParameters: GetVulnerabilityScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VulnerabilityScannerMappingStalenessResponse> {
        const response = await this.getVulnerabilityScannerMappingStalenessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert scanner mapping row
     */
    async upsertVulnerabilityScannerMappingRaw(requestParameters: UpsertVulnerabilityScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerMappingDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling upsertVulnerabilityScannerMapping().'
            );
        }

        if (requestParameters['vulnerabilityScannerMappingUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityScannerMappingUpsertRequest',
                'Required parameter "vulnerabilityScannerMappingUpsertRequest" was null or undefined when calling upsertVulnerabilityScannerMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/vulnerabilities/scanner-mappings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VulnerabilityScannerMappingUpsertRequestToJSON(requestParameters['vulnerabilityScannerMappingUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScannerMappingDtoFromJSON(jsonValue));
    }

    /**
     * Upsert scanner mapping row
     */
    async upsertVulnerabilityScannerMapping(requestParameters: UpsertVulnerabilityScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerMappingDto> {
        const response = await this.upsertVulnerabilityScannerMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
